var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "custom-tabs2",
              on: { "tab-click": _vm.toggleTabs },
              model: {
                value: _vm.groupId,
                callback: function ($$v) {
                  _vm.groupId = $$v
                },
                expression: "groupId",
              },
            },
            _vm._l(_vm.tabsList, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.name, name: item.value },
              })
            }),
            1
          ),
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                { staticClass: "title-btn-item", on: { click: _vm.add } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("新增审批表")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.list,
              pagination: "",
              total: _vm.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.pageNo,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("move-group", {
        ref: "MoveGroup",
        on: {
          success: function ($event) {
            return _vm.fetchData()
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.changeDialog,
            width: "30%",
            "append-to-body": true,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeDialog = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(
              "是否确认" +
                _vm._s(_vm.currentItem.isStop ? "启用" : "停用") +
                "？"
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.changeDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnStopLoading },
                  on: { click: _vm.onChangeStatus },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "选择对象", multiple: "" },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("数据列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }